import { render, staticRenderFns } from "./image_aliment.vue?vue&type=template&id=0bb2a839&"
import script from "./image_aliment.vue?vue&type=script&lang=ts&"
export * from "./image_aliment.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports